import { ButtonHTMLAttributes, forwardRef } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const base =
  'inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition disabled:opacity-50 disabled:cursor-not-allowed';

const styles: Record<Variant, string> = {
  primary: 'bg-brand-dark text-paper hover:bg-brand-dark/90',
  secondary: 'bg-paper text-ink border border-border hover:bg-surface-alt/50',
  ghost: 'bg-transparent text-ink hover:bg-surface-alt/70',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', className = '', ...rest },
  ref,
) {
  return <button ref={ref} className={`${base} ${styles[variant]} ${className}`} {...rest} />;
});
